<div class="form-section permissions-section w-100 mt-2 p-0" [formGroup]="form">
  <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
    <div class="d-flex align-items-center p-1">
      <img
        class="section-image"
        src="../../assets/icon/add-section-white.svg"
        alt="permissions"
        style="width: 24px; height: 24px"
        />
    </div>
    <div class="form-title-text-container">
      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
        {{ 'USER_FORM.PERMISSIONS' | translate }}
      </p>
    </div>
  </div>

  <div class="permissions-grid">
    @for (permission of availablePermissions; track permission) {
      <div class="permission-item">
        <button
          type="button"
          class="btn rounded d-flex align-items-center justify-content-center mb-1 w-100 permission-button"
        [ngStyle]="
          isPermissionSelected(permission.id.toString())
            ? {
                background: '#E30613',
                borderColor: '#E30613',
                color: '#fff',
                opacity: !isCurrentUserAdmin ? '0.6' : '1',
                cursor: !isCurrentUserAdmin ? 'not-allowed' : 'pointer'
              }
            : {
                background: '#fff',
                borderColor: '#6c757d',
                color: '#6c757d',
                opacity: !isCurrentUserAdmin ? '0.6' : '1',
                cursor: !isCurrentUserAdmin ? 'not-allowed' : 'pointer'
              }
        "
      (click)="onPermissionSelection(permission.id.toString(), !isPermissionSelected(permission.id.toString()))"
      >
      <img
          [src]="
            '../../assets/icon/' +
            ((permission.id + '').toLowerCase() === 'request'
              ? 'info-circle'
              : (permission.id + '').toLowerCase() === 'final-users'
                ? 'home'
                : (permission.id + '').toLowerCase()) +
            (isPermissionSelected(permission.id.toString()) ? '-white.svg' : '-light.svg')
          "
        alt="permission-icon"
        class="img-fluid"
        style="width: 32px; height: 32px; object-fit: contain"
        />
    </button>
    <div
      class="small fw-semibold text-center w-100"
        [ngStyle]="{
          color: !isLight ? '#ffffff' : isPermissionSelected(permission.id.toString()) ? '#111' : '#6c757d'
        }"
      >
      {{ permission.value | translate }}
    </div>
  </div>
}
</div>
</div>
